import type { AxiosInstance } from 'axios';
import type {
  ChartWaypoint,
  ChartWaypointListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getChartWaypoints = async (
  api: AxiosInstance,
  chart_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<ChartWaypointListResponse> => {
  const resp = await api.get<ChartWaypointListResponse>(`/chart/${chart_id}/waypoint`, {
    params: { limit, start_key, name } as ListQueryParams,
  });
  return resp.data;
};

export const getChartWaypoint = async (
  api: AxiosInstance,
  chart_id: EntityId,
  waypoint_id: EntityId,
): Promise<ChartWaypoint> => {
  const resp = await api.get<ChartWaypoint>(
    `/chart/${chart_id}/waypoint/${waypoint_id}`,
  );
  return resp.data;
};

export const createChartWaypoint = async (
  api: AxiosInstance,
  chart_id: EntityId,
  values: Omit<ChartWaypoint, 'entity_id' | 'chart_id' | 'created_at' | 'updated_at'>,
): Promise<ChartWaypoint> => {
  const resp = await api.post<ChartWaypoint>(`/chart/${chart_id}/waypoint`, values);
  return resp.data;
};

export const updateChartWaypoint = async (
  api: AxiosInstance,
  chart_id: EntityId,
  waypoint_id: EntityId,
  values: Partial<Omit<ChartWaypoint, 'entity_id' | 'chart_id' | 'created_at' | 'updated_at'>>,
): Promise<ChartWaypoint> => {
  const resp = await api.put<ChartWaypoint>(
    `/chart/${chart_id}/waypoint/${waypoint_id}`,
    values,
  );
  return resp.data;
};

export const deleteChartWaypoint = async (
  api: AxiosInstance,
  chart_id: EntityId,
  waypoint_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/chart/${chart_id}/waypoint/${waypoint_id}`);
  return resp.data;
};

